import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteFeature, getFeatures } from "../../redux/services/featureSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const Features = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getFeatureData = useSelector((state) => state?.feature?.featureData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllFeatures = useCallback(async () => {
    try {
      await dispatch(getFeatures({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllFeatures();
  }, [getAllFeatures]);

  const deleteFeatureData = async () => {
    try {
      const response = await dispatch(deleteFeature(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllFeatures();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Title", key: "title" },
    { header: "Description", key: "description" },
    {
      header: "Thumbnail",
      key: "thumbnailImage",
      render: (thumbnailImage) => (
        <img
          src={thumbnailImage}
          alt="thumbnail"
          className="w-20 h-14 object-cover rounded-xl"
        />
      ),
    },
    {
      header: "Link",
      key: "link",
      render: (link) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-primary underline">
          Visit
        </a>
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WEBSITE.FEATURES_ADD_EDIT}?featureId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="Features"
        buttonTitle="Add Feature"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WEBSITE.FEATURES_ADD_EDIT)}
        columns={columns}
        data={getFeatureData?.feature_data || []}
        actions={actions}
        pageCount={getFeatureData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Feature"
          confirm={confirm}
          onDelete={deleteFeatureData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default Features;
